import { WrapPage, Linker, Icon } from 'common/ui'
import { appConfig } from '@/constants'
import styled from 'styled-components'
import { makeDAppUrl, makeNFTUrl, makeTokenUrl } from '@/utils'

const HomeStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: absolute;
  .card {
    width: 264px;
    height: 360px;
    border-radius: 20px;
    cursor: pointer;
    border: 1px solid #3a3939;
    padding: 40px;
    text-decoration: none;
    transition: all 0.7s ease-in-out;
    background: #1a1919;
    img {
      width: 112px;
      height: 112px;
    }
    .name {
      font-weight: 700;
      font-size: 24px;
      line-height: 24px;
      margin-top: 40px;
      margin-bottom: 50px;
      color: #ffffff;
      .letter {
        letter-spacing: 2px;
      }
    }
    &:not(:last-child) {
      margin-right: 64px;
    }
    &:hover {
      border-color: #e0c286;
      background: linear-gradient(
          180deg,
          rgba(224, 194, 134, 0) 50%,
          rgba(224, 194, 134, 0.1) 100%
        ),
        #1a1919;
      .name,
      .icon {
        color: #e0c286;
      }
    }
  }
  .icon {
    color: #6b6b6b;
    font-size: 40px;
  }
`
const Home = () => {
  const cardList = [
    // {
    //   name: (
    //     <>
    //       {/* fix some system letter is small  */}N<span className="letter">F</span>Ts
    //     </>
    //   ),
    //   img: '/img/nft-logo.png',
    //   id: 'nft',
    //   path: makeNFTUrl(),
    // },
    {
      name: 'Tokens',
      img: '/img/token-logo.png',
      id: 'token',
      path: makeTokenUrl(),
    },
    {
      name: 'DApps',
      img: '/img/dapp-logo.png',
      id: 'dapp',
      path: makeDAppUrl(),
    },
  ]
  return (
    <HomeStyled>
      {cardList.map((card) => (
        <Linker href={card.path} className="card" key={card.id}>
          <img src={card.img} alt={card.id} />
          <div className="name">{card.name}</div>
          <Icon type="in-dapp" className="icon" />
        </Linker>
      ))}
    </HomeStyled>
  )
}

export default WrapPage(Home, { ...appConfig, bg: '/img/bg.png' })
